import { useNavigate } from 'react-router-dom'

const About = () => {
  const navigate = useNavigate()
  return (
    <div>
      <strong>Help - Member Reimbursement Categories</strong>
      <ul className="ul list-none">
        <li className="text-left text-cyan-600 py-2">Housing</li>
        <li className="text-left">
          For housing/rent reimbursements/allowances or housing stays over 1
          month long.
        </li>
        <li className="text-left text-cyan-600 py-2">Travel</li>
        <li className="text-left">
          For all member travel including mileage, per diem, fuel, food, hotels,
          flights, baggage fees, shuttles, ferry tickets, parking fees, toll
          tickets, relocation expenses, camping fees
        </li>
        <li className="text-left text-cyan-600 py-2"> Uniforms </li>
        <li className="text-left">
          For all member uniforms and gear such as work pants, boots, socks,
          rain jackets, etc.
        </li>
        <li className="text-left text-cyan-600 py-2">Training</li>
        <li className="text-left">
          For all member Training Courses or Conference fees
        </li>
        <li className="text-left text-cyan-600 py-2"> Safety Supplies </li>
        <li className="text-left">
          For all member safety supplies such as bug spray, sunscreen, PPE
          (gloves), etc
        </li>
        <li className="text-left text-cyan-600 py-2"> Project Supplies </li>
        <li className="text-left">
          For all member project supplies and tools (hand tools, clippers,
          buckets, waders, clipboards)
        </li>
        <li className="text-left text-cyan-600 py-2">
          {' '}
          Vehicle Maintenance and Supplies{' '}
        </li>
        <li className="text-left">For all vehicle maintenance and supplies</li>
      </ul>
      <button onClick={() => navigate(-1)} className="primary-button">
        Go back
      </button>
    </div>
  )
}
export default About
